import React, { useState, useRef, useEffect } from 'react';

function Dimmer() {
  const progressRef = useRef();
  const step = 1;
  const interval = 100;
  const maxProgress = 100;
  const [progressPercentage, setProgressPercentage] = useState(0);

  useEffect(() => {
    const updateProgress = () => setProgressPercentage(progressPercentage + step);
    let timer;
    if (progressPercentage < maxProgress) {
      timer = setTimeout(updateProgress, interval);
    }
    return () => clearTimeout(timer);
  }, [progressPercentage]);

  return (
    <>
      <div className="disable-overlay" title="disable-overlay" />
      <div className="progress-container">
        <div
          className="progress-done"
          ref={progressRef}
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </>
  );
}

export default Dimmer;

Dimmer.propTypes = {

};

Dimmer.defaultProps = {

};
